<div
  class="pointer-events-none fixed bottom-4 right-4 z-[2000] flex w-[90vw] max-w-sm flex-col gap-2"
>
  @for (toast of toastService.toasts(); track toast) {
    <div
      class="pointer-events-auto rounded-xl border px-4 py-3 text-sm shadow-lg"
      [class]="getToastClass(toast.classname)"
    >
      <div class="flex items-start justify-between gap-3">
        <span>{{ toast.text }}</span>
        <button
          class="rounded p-1 text-xs opacity-70 transition hover:opacity-100"
          (click)="toastService.remove(toast)"
          aria-label="Cerrar"
        >
          <i class="bi bi-x"></i>
        </button>
      </div>
    </div>
  }
</div>
